import * as STD                                    from '@emersya/mpa-std-lib';
import * as BasketNS                               from '@emersya/mpa-basket-lib';
import CM                                          from '@emersya/mpa-components-manager-lib';
import { Block, InputSelect, MenuAccordion, Text } from '@emersya/mpa-components-lib';
// import { Block, InputSelect, Image, Text } from '@emersya/mpa-components-lib';
import ViewerComponent                             from '../../../Viewer/Viewer';

export interface IPlannerWallsEditorComponentConfiguration extends Block.Configuration {
	// translations : Record<string, STD.translationsManager.TranslationMapping>;
	forceBackgroundColor? : string | null;
};

export class PlannerWallsEditorComponent extends Block.Component {
	readonly plannerCategory! : ViewerComponent.ProductCategory;

	get layoutId() {
		const currentProduct = app.currentProduct;
		if (!currentProduct) {
			return null;
		}
		const layoutPart = currentProduct.getPart([ 'layout' ]);
		if (!layoutPart) {
			return null;
		}
		const currentOption = layoutPart.currentOption;
		if (!currentOption) {
			return null;
		}
		return currentOption.id.replace('shape-', '');
	};

	get wallColorsBasketPart() {
		if (!app.currentProduct) {
			this.component_throwUserError('');
		}
		const part = app.currentProduct.parts.find(x => x.id === 'wall');
		if (!part) {
			this.component_throwLibraryError('');
		}
		return part;
	}

	async updateSize() {
		await app.viewer.freezeRendering({ keepCount : true });
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeUpdate();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	};

	async instantiateMenu(event : STD.events.Event<any, CM.Component<any, any>>) {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwLibraryError('');
		}
		const wallPart = app.currentProduct.getPart([ 'wall' ]);
		const fieldContent = this.component_find('@:colorSelector:content');
		if (fieldContent.component_outerChilds.length) {
			for (const x of fieldContent.component_outerChilds) {
				await x.component_delete();
			}
			await wallPart.unuseOption();
		}
		const layoutPart = app.currentProduct.getPart([ 'layout' ]);
		const layoutOptionSKU = layoutPart?.currentOption?.reference?.value || null;


		if (!fieldContent.component_outerChilds.length && layoutOptionSKU && layoutOptionSKU !== 'shape-no-wall') {
			const defaultWallColorSKU = app.currentDefaults.wall;
			const inputSelect = <InputSelect.Component> await fieldContent.component_instantiateOuterChild<InputSelect.Configuration>(
				{
					type :          'input-select',
					id :            'options',
					tree :          this.component_tree,
					slot :          null,
					isSlot :        false,
					declaredSlot :  null,
					configuration : {
						'renderingMode' : 'radio',
						defaultValue :    defaultWallColorSKU || null
					}
				}
			);
			const wallOptionsDescriptors = app.component_configuration.productsOptions.filter(x => x.component === 'wall');
			if (!wallOptionsDescriptors) {
				this.component_throwUserError('');
			}

			await app.fillComponentOptions(
				this,
				wallPart,
				inputSelect,
				wallOptionsDescriptors,
				'viewer-planner-walls-optionTile',
				event
			);
			await inputSelect.component_initialize();
			await inputSelect.component_start(event);
			let checkOptions = false;
			const optionsEnabled = app.component_configuration.productsOptions.filter(x => x.component ===
				'wall' &&
				x.products.includes(product.id));
			const optionsInfos = wallOptionsDescriptors.filter(x => optionsEnabled.find(y => y.SKU === x.SKU)).
			map(optionDescriptor => {
				const option = wallPart.options.find(x => x.id === optionDescriptor.SKU);
				if (!option) {
					this.component_throwLibraryError('');
				}
				return {
					descriptor : optionDescriptor,
					option
				};
			});
			const optionnalOptions = optionsInfos.filter(x => x.option.pricingInfo &&
				!x.option.pricingInfo.pricing.resolve().isNull());
			const titleOptionalOptions = inputSelect.component_DOM.querySelectorAll('h3')[ 1 ];
			if (titleOptionalOptions && optionnalOptions.length === 0) {
				titleOptionalOptions.style.display = 'none';
			}
			for (const children of inputSelect.component_outerChilds) {
				// if((<PlannerWallsProductTileNS.Component>children).component_DOM.classList.contains('selected')){
				// 	await wallPart.useOption(children.id);
				// }
				if (optionsEnabled.find(x => x.SKU === children.id) && children.component_isDisabled) {
					checkOptions = true;
					await children.component_enable();
				} else if (!optionsEnabled.find(x => x.SKU === children.id)) {
					await children.component_disable();
				} else {
					checkOptions = true;
				}
			}
			const fieldHeader = this.component_find('@:colorSelector:header');
			if (checkOptions) {
				await fieldHeader.component_enable();
			} else {
				await fieldHeader.component_disable();
			}
		}


		STD.translationsManager.update(this.component_DOM);
	};

	get walls() {
		const menuAccordion = this.component_find('@:menu');
		return <PlannerWallsProductTileNS.Component[]> menuAccordion.component_outerChilds;
	};

	async updateLayout() {
		if (!app.basket || !app.basket.basket.currentProduct) {
			return;
		}
		const selectedLayout = app.basket.basket.currentProduct.getPart([ 'layout' ]).currentOption?.id.replace('shape-', '');
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeRemove();
		}
		await this.instantiateMenu(this.component_getEventWhichRepresentNoEvent());
		if (selectedLayout && (selectedLayout !== 'no-wall')) {
			for (const wallComponent of this.walls) {
				if (selectedLayout.includes(wallComponent.id)) {
					await wallComponent.viewerNodeInsert();
				}
			}
		}
	};

	async update() {
		if (!this.layoutId) {
			return;
		}
		await app.viewer.freezeRendering({ keepCount : true });
		await this.updateLayout();
		await this.updateSize();
		await app.viewer.unfreezeRendering({ keepCount : true });
	};

	checkWallCustomImageDisplay() {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('');
		}
		const menuAccordion = <MenuAccordion.Component> this.component_find('@:menu');
		const titleMenu = <Text.Component> this.component_find('@:title');
		if (product.id === 'siae' || product.id === 'confort') {
			menuAccordion.component_DOM.style.display = 'block';
			titleMenu.component_DOM.style.display = 'block';
		} else {
			menuAccordion.component_DOM.style.display = 'none';
			titleMenu.component_DOM.style.display = 'none';
		}
	};

	async clear() {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('');
		}
		if (app.isReloading) {
			return;
		}
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeRemove();
		}
	};

	async onColorValueUpdated() {
		const select = <InputSelect.Component> this.component_find('@:colorSelector:content.options');
		const option = select.value;
		if (!app.basket || !app.currentProduct) {
			this.component_throwLibraryError('');
		}
		const wallPart = app.currentProduct.getPart([ 'wall' ]);
		if (!option) {
			if (wallPart.currentOption) {
				await wallPart.unuseOption();
			}
		} else {
			if (wallPart.currentOption && wallPart.currentOption.id === option.id) {
				return;
			}
			await wallPart.useOption(option.id);
		}

	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			const part = product.createPart({
				id :        'wall',
				title :     'Wall',
				reference : null,
				metaData :  null,
				parts :     [],
				options :   []
			});
			await part.initialize();
		}
	};

	getConfiguratorMenu(event : STD.events.Event<any, any>) {
		const product = <ViewerComponent.ProductInstance> event.details.product;
		const wallId = product.metadata.id;
		const wall = this.walls.find(x => x.id === wallId);
		if (!wall) {
			return;
		}
		return wall.getMenuConfigurator();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		const mod = app.modules.used.find(x => x.id === 'viewer-planner-walls-editor');
		if (!mod) {
			this.component_throwUserError('');
		}
		const wallProductNodeComponents = app.component_configuration.productsComponents.filter(x => x.type === '@wall');
		const editor = this;
		void editor;
		const viewerCustomPatchProductNodeComponents = app.component_configuration.productsComponents.find(x => x.type ===
			'@viewerCustomPatch');
		if (!viewerCustomPatchProductNodeComponents) {
			this.component_throwUserError('No "@viewerCustomPatch" component defined!');
		}
		(<any> this).plannerCategory = app.viewer.createCategory({
			name :        'Wall',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    wallProductNodeComponents.reduce<ViewerComponent.Product.IDescriptor[]>((a, c) => {
				for (const productSKU of c.products) {
					const wallSKU = `@wall-${ productSKU }`;
					const productDescriptor : ViewerComponent.Product.IDescriptor = {
						SKU :   wallSKU,
						nodes : [
							{
								localId :                     'global',
								SKU :                         <string> c.viewerComponentSKU,
								projectCode :                 <string> c.viewerProjectCode,
								parentLocalId :               'root',
								doNotListAsProductComponent : true,
								tracked :                     true,
								draggable :                   false,
								matrix :                      app.viewer.mtx(
									[ 0, 0, 0 ],
									[ 1, 1, 1 ],
									0
								)
							}, {
								localId :                     'customImage',
								SKU :                         <string> viewerCustomPatchProductNodeComponents.viewerComponentSKU,
								projectCode :                 <string> viewerCustomPatchProductNodeComponents.viewerProjectCode,
								parentLocalId :               'global',
								doNotListAsProductComponent : true,
								tracked :                     true,
								draggable :                   false,
								matrix :                      app.viewer.mtx(
									[ 0, 0, 0.01 ],
									[ 1, 1, 1 ],
									0
								)
							}
						]
					};
					if (productSKU === 'siae' || productSKU === 'confort') {
						app.viewer.productsExtensionById[ wallSKU ] = {
							quantity :        null,
							configuratorGet : CM.PropertyOperation.CallOperation.create({
								type :          'call',
								componentPath : this.component_getPath(),
								propertyPath :  'getConfiguratorMenu',
								parameters :    []
							}),
							customImages :    [
								{
									id :       'customImg',
									title :    { en : 'Add logo', fr : 'Ajouter un logo' },
									width :    5,
									height :   5,
									mesh :     'PATCH_CLOISON',
									material : {
										name :          'PATCH_CLOISON',
										configuration : {
											enabled :  'PATCH_CLOISON',
											disabled : 'off'
										}
									},
									getLocalId(customImageId : string) {
										void customImageId;
										const wallComponent = editor.walls.find(x => x.id === this.metadata.id);
										if (!wallComponent) {
											// editor.component_throwLibraryError('');
											throw STD.errors.library(''); // TS BUG
										}
										return <number> wallComponent.viewerNode?.idMapping[ 'customImage' ];
									},
									getSizeX(customImageId : string) {
										void customImageId;
										const wallComponent = editor.walls.find(x => x.id === this.metadata.id);
										if (!wallComponent) {
											// editor.component_throwLibraryError('');
											throw STD.errors.library(''); // TS BUG
										}
										return wallComponent.getWallImageCustomizationZone().size.x;
									},
									getSizeY(customImageId : string) {
										void customImageId;
										const wallComponent = editor.walls.find(x => x.id === this.metadata.id);
										if (!wallComponent) {
											throw STD.errors.library('');
											// editor.component_throwLibraryError(''); // TS BUG
										}
										return wallComponent.getWallImageCustomizationZone().size.y;
									},
									pricingInfo :       {
										pricing : <BasketNS.Pricing.FinalPricing.ISerialized> {
											type :  'final',
											price : {
												exclTax : 245
											}
											// '*' : {
											// 	0 : {
											// 		exclTax : 245
											// 	}
											// }
										},
										// price :              {
										// 	'*' : {
										// 		0 : {
										// 			exclTax : 245
										// 		}
										// 	}
										// },

									},
									volumeComputation : {
										boundTo :          'surface-image-m.width',
										roundingStrategy : 'none'
									}
								}
							]
						};
					}
					a.push(productDescriptor);
				}
				return a;
			}, [])
		});
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerWallsEditorComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			header : <Block.Configuration> {
				'@innerConfigurations' : {
					label : <Text.Configuration> {
						'@translations' : {
							text : configuration[ '@translations' ]?.label
						}
					}
				}
			},
			menu :   {
				'@innerConfigurations' : {
					left :  <PlannerWallsProductTileNS.Configuration> {
						forceBackgroundColor : configuration.forceBackgroundColor
					},
					right : <PlannerWallsProductTileNS.Configuration> {
						forceBackgroundColor : configuration.forceBackgroundColor
					},
					back :  <PlannerWallsProductTileNS.Configuration> {
						forceBackgroundColor : configuration.forceBackgroundColor
					}
				}
			}
		};
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerWallsEditorComponent;
	export type Component = PlannerWallsEditorComponent;
	export type Configuration = IPlannerWallsEditorComponentConfiguration;
}

import manifestXMLSource                   from './PlannerWallsEditor.xml';
import './PlannerWallsEditor.scss';
import { NS as PlannerWallsProductTileNS } from '../ProductTile/PlannerWallsProductTile';
// import { NS as PlannerWallsOptionTileNS }  from '../OptionTile/PlannerWallsOptionTile';

CM.declare({
	id :       'viewer-planner-walls-editor',
	type :     PlannerWallsEditorComponent,
	manifest : manifestXMLSource
});
